const configNode = document.querySelector('#ents-wishlist-config') as HTMLElement;

export interface Config {
  apiEndpoint?: string
  currentlyLoggedIn?: string
  displayedItemCount?: string
  sandboxMode?: boolean
  messageWishlistTextActive?: string
  messageWishlistTextInactive?: string
  messageButtonAriaLabel?: string
  currency?: string
  country?: string
  assetsHost?: string
  homepage?: string
}

export const config = (configNode?.dataset ?? {}) as Config;

export const ADDED_TO_WISHLIST_EVENT = 'ents:wishlist:added';
export const REMOVED_FROM_WISHLIST_EVENT = 'ents:wishlist:removed';
export const ADD_TO_WISHLIST_EVENT = 'ents:wishlist:add';
export const REMOVE_FROM_WISHLIST_EVENT = 'ents:wishlist:remove';
export const REMOVE_COUNT_FROM_WISHLIST_EVENT = 'ents:wishlist:remove:bulk:count';
export const LOGGED_OUT_EVENT = 'ents:wishlist:user-logged-out';
